import Auth from '@aws-amplify/auth';

const getAuthenticatedUser = () => Auth.currentAuthenticatedUser();

const logout = () => {
  Auth.signOut();
  if (localStorage.getItem('ssoUsername')) {
    localStorage.removeItem('ssoUsername');
  }
};

export { logout };

export default getAuthenticatedUser;
